import {atom} from 'recoil';

const loggedIn = atom({key: 'loggedIn', default: null});
const loggedInData = atom({key:"loggedInData",default:{}})
const loading = atom({key: 'loading', default: false});
const panel = atom({key: 'panel', default: ''});

export default {loggedIn, loading, panel, loggedInData};
